import { getSiteCopy } from "../data/i18n";
import { applyPageSeo } from "../lib/seo";
import { homePath } from "../lib/routing";
import type { Locale } from "../types";

type NotFoundPageProps = {
  locale: Locale;
  pathname: string;
};

export function NotFoundPage({ locale, pathname }: NotFoundPageProps) {
  const copy = getSiteCopy(locale);

  applyPageSeo({
    title: `${copy.notFoundTitle} - TextPolish Tools`,
    description: copy.notFoundBody,
    locale,
    path: pathname
  });

  return (
    <main className="static-page" id="main-content">
      <h1>{copy.notFoundTitle}</h1>
      <p>{copy.notFoundBody}</p>
      <a className="primary-link" href={homePath(locale)}>
        {copy.returnHome}
      </a>
    </main>
  );
}
